import React from 'react';
import './styles.css';
import GetJoke from './GetJoke';

function App() {
  return (
    <div className="app">
      <GetJoke />
    </div>
  );
}

export default App;
